/**
 * Interacción de la landing: lo que no es animación de entrada sino estado.
 *
 *   data-pasos        Bloque de los pasos del comité. Dentro:
 *     data-paso="i"          Botón (role="tab") de cada paso.
 *     data-paso-panel        Maqueta de cada paso (role="tabpanel"), en orden.
 *     data-paso-progreso     Barra bajo cada botón que marca el tiempo hasta
 *                            el siguiente.
 *     data-paso-numero / data-paso-titulo   Rótulo «Paso N de 4 · Título».
 *   data-palabras     Palabra del titular que rota («congreso», «jornada»…).
 *                     Lleva la lista en JSON; sin JS se queda la primera.
 *   data-barra-fija   Barra de «Pide una demo» que aparece al bajar del héroe y
 *                     se retira al llegar a [data-contacto].
 *
 * Sin JS los pasos muestran el primero y los botones no hacen nada; la barra
 * fija no aparece nunca. Nada de lo importante depende de esto.
 */

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const PASO_MS = 4000;

function initPasos() {
    const bloque = document.querySelector('[data-pasos]');
    if (!bloque) {
        return;
    }

    const botones = [...bloque.querySelectorAll('[data-paso]')];
    const paneles = [...bloque.querySelectorAll('[data-paso-panel]')];
    const numero = bloque.querySelector('[data-paso-numero]');
    const titulo = bloque.querySelector('[data-paso-titulo]');

    let actual = 0;
    let temporizador = null;

    const autoplay = () => !reduceMotion.matches;

    function mostrar(indice) {
        actual = indice;

        botones.forEach((boton, i) => {
            boton.setAttribute('aria-selected', i === indice ? 'true' : 'false');
            boton.tabIndex = i === indice ? 0 : -1;

            const progreso = boton.querySelector('[data-paso-progreso]');
            progreso.getAnimations().forEach((a) => a.cancel());
            progreso.style.width = '0';
        });

        paneles.forEach((panel, i) => {
            panel.hidden = i !== indice;
        });

        if (numero) {
            numero.textContent = indice + 1;
        }
        if (titulo) {
            titulo.textContent = botones[indice].querySelector('[data-paso-nombre]').textContent;
        }

        const progreso = botones[indice].querySelector('[data-paso-progreso]');

        if (!autoplay()) {
            progreso.style.width = '100%';
            return;
        }

        paneles[indice].animate(
            [{ opacity: 0, transform: 'translateY(16px) scale(.98)' }, { opacity: 1, transform: 'none' }],
            { duration: 600, easing: 'cubic-bezier(.16,1,.3,1)' }
        );
        progreso.animate([{ width: '0%' }, { width: '100%' }], {
            duration: PASO_MS,
            easing: 'linear',
            fill: 'forwards',
        });
    }

    function programar() {
        clearInterval(temporizador);
        if (autoplay()) {
            temporizador = setInterval(() => mostrar((actual + 1) % botones.length), PASO_MS);
        }
    }

    botones.forEach((boton, i) => {
        boton.addEventListener('click', () => {
            mostrar(i);
            programar();
        });

        // Flechas entre pestañas, como pide el patrón ARIA de tabs.
        boton.addEventListener('keydown', (evento) => {
            const salto = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[evento.key];
            if (!salto) {
                return;
            }
            evento.preventDefault();
            const siguiente = (i + salto + botones.length) % botones.length;
            botones[siguiente].focus();
            mostrar(siguiente);
            programar();
        });
    });

    mostrar(0);
    programar();
}

const PALABRA_MS = 2400;

function initPalabras() {
    const hueco = document.querySelector('[data-palabras]');
    if (!hueco || reduceMotion.matches) {
        return;
    }

    let palabras;
    try {
        palabras = JSON.parse(hueco.dataset.palabras);
    } catch {
        return;
    }
    if (!Array.isArray(palabras) || palabras.length < 2) {
        return;
    }

    let actual = 0;
    setInterval(() => {
        hueco.animate(
            [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-.18em)' }],
            { duration: 220, easing: 'ease-in', fill: 'forwards' }
        ).finished.then(() => {
            actual = (actual + 1) % palabras.length;
            hueco.textContent = palabras[actual];
            hueco.animate(
                [{ opacity: 0, transform: 'translateY(.18em)' }, { opacity: 1, transform: 'none' }],
                { duration: 320, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' }
            );
        });
    }, PALABRA_MS);
}

function initBarraFija() {
    const barra = document.querySelector('[data-barra-fija]');
    if (!barra) {
        return;
    }

    const contacto = document.querySelector('[data-contacto]');

    const actualizar = () => {
        const antesDelContacto = !contacto || contacto.getBoundingClientRect().top > window.innerHeight * 0.85;
        const visible = window.scrollY > 620 && antesDelContacto;
        barra.toggleAttribute('data-visible', visible);
        barra.inert = !visible;
    };

    window.addEventListener('scroll', actualizar, { passive: true });
    actualizar();
}

function boot() {
    initPasos();
    initPalabras();
    initBarraFija();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
    boot();
}
